import { WarningRounded } from '@ticketswap/solar/icons'
import { useToast, Toast, color } from '@ticketswap/solar'
import { useEffect, useRef } from 'react'

const NetworkStatus = () => {
  const { notify } = useToast()
  const reset = useRef(() => {})

  useEffect(() => {
    const isBrowser = typeof window !== 'undefined'

    const handleStatusChange = ({ type }) => {
      if (type === 'offline') {
        notify(remove => {
          reset.current = remove
          return (
            <Toast persist leftAdornment={<WarningRounded size={24} color={color.mars} />}>
              You are offline
            </Toast>
          )
        })
      } else {
        reset.current()
      }
    }

    if (isBrowser) {
      window.addEventListener('online', handleStatusChange)
      window.addEventListener('offline', handleStatusChange)
    }

    return () => {
      if (isBrowser) {
        window.removeEventListener('online', handleStatusChange)
        window.removeEventListener('offline', handleStatusChange)
      }
    }
  }, [notify])

  return null
}

export default NetworkStatus
